import { BoardContainer } from "../BoardContainer";
import { GameVars } from "../../../../GameVars";
import { ScoreLayer } from "./ScoreLayer";
import { PositionLayer } from "./PositionLayer";
import { PointsLayer } from "./PointsLayer";
import { AI } from "../../AI";
import { AudioManager } from "../../../../AudioManager";

export class AdversaryContainer extends Phaser.GameObjects.Container {

    private static POSITION = [
        {x: -450, y: 0},
        {x: 0, y: -310},
        {x: 450, y: 0}
    ];

    private static INITIAL_PASS_POSITION = [
        {x: -300, y: -200},
        {x: 270, y: -330},
        {x: 300, y: 200}
    ];

    private static PASS_POSITION = [
        {x: 0, y: -200},
        {x: 270, y: -30},
        {x: 0, y: 200}
    ];

    private static TOCKENS_POSITION = [
        {x: 0, y: -320},
        {x: 270, y: 80},
        {x: 0, y: 320}
    ];

    private static LOSE_POSITION = [
        {x: -400, y: 0},
        {x: 0, y: -400},
        {x: 400, y: 0}
    ];

    private passContainer: Phaser.GameObjects.Container;
    private passText: Phaser.GameObjects.Text;
    private passPoints: Phaser.GameObjects.Text;
    private passAvatar: Phaser.GameObjects.Image;
    private scoreLayer: ScoreLayer;
    private positionLayer: PositionLayer;
    private pointsLayer: PointsLayer;

    private tokens: Phaser.GameObjects.Image[];

    private index: number;

    private AI: AI;

    constructor(scene: Phaser.Scene, index: number) {

        super(scene);

        this.x = AdversaryContainer.POSITION[index - 1].x;
        this.y = AdversaryContainer.POSITION[index - 1].y;

        this.index = index;

        this.passContainer = new Phaser.GameObjects.Container(this.scene, AdversaryContainer.INITIAL_PASS_POSITION[this.index - 1].x, AdversaryContainer.INITIAL_PASS_POSITION[this.index - 1].y);
        this.passContainer.setAngle(-3);
        this.add(this.passContainer);

        let passBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_language", "player-pass");
        this.passContainer.add(passBackground);

        this.passAvatar = new Phaser.GameObjects.Image(this.scene, -70, 10, "texture_atlas_1");
        this.passAvatar.setScale(.5);
        this.passContainer.add(this.passAvatar);

        this.passText = new Phaser.GameObjects.Text(this.scene, -10, -32, "", {fontFamily: "HelveticaNeue", fontSize: "25px", color: "#FFFFFF"});
        this.passContainer.add(this.passText);

        this.passPoints = new Phaser.GameObjects.Text(this.scene, -15, 20, "", {fontFamily: "HelveticaNeue", fontSize: "30px", color: "#0a2f76"});
        this.passContainer.add(this.passPoints);

        this.tokens = [];

        for (let i = 0; i < 3; i++) {

            let token = new Phaser.GameObjects.Image(this.scene, 
                -80 + 80 * i + AdversaryContainer.TOCKENS_POSITION[this.index - 1].x, 
                AdversaryContainer.TOCKENS_POSITION[this.index - 1].y + Math.random() * 20 - 10, 
                "texture_atlas_language", "token");
            token.setAngle(Math.random() * 360 - 180);
            token.setAlpha(0);
            token.setScale(2);
            this.add(token);
            this.tokens.push(token);
        }

        this.scoreLayer = new ScoreLayer(this.scene, index);
        this.add(this.scoreLayer);

        this.positionLayer = new PositionLayer(this.scene, index);
        this.add(this.positionLayer);

        this.pointsLayer = new PointsLayer(this.scene, index);
        this.add(this.pointsLayer);

        this.AI = new AI();
        this.AI.init(this.index);
    }

    public startGame(): void {

        this.passText.setText(GameVars.players[this.index].name);
        this.passPoints.setText(GameVars.players[this.index].points.toString());
        this.passAvatar.setFrame("avatar_" + GameVars.players[this.index].gender + "_" + GameVars.players[this.index].avatarId);

        this.scene.tweens.add({
            targets: this.passContainer,
            x: AdversaryContainer.PASS_POSITION[this.index - 1].x,
            y: AdversaryContainer.PASS_POSITION[this.index - 1].y,
            ease: Phaser.Math.Easing.Cubic.Out,
            delay: 1000 + 250 * this.index,
            duration: 500,
            onStart: () => {
                AudioManager.playSound("cards_out");
            },
            onStartScope: this
        });

        for (let i = 0; i < 3; i++) {
            this.scene.tweens.add({
                targets: this.tokens[i],
                scaleX: 1,
                scaleY: 1,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                delay: 2250 + i * 250,
                duration: 500,
                onStart: () => {
                    AudioManager.playSound("token");
                },
                onStartScope: this
            });
        }

        this.resetAI();
    }

    public showScores(): void {
        
        for (let i = 0; i < GameVars.players[this.index].cards.length; i++) {
            this.scene.time.addEvent({ delay: 250 * i, callback: () => {
                BoardContainer.currentInstance.deckContainer.getCard(GameVars.players[this.index].cards[GameVars.players[this.index].cards.length - 1 - i]).flip();
            }, callbackScope: this}); 
        }

        this.scene.time.addEvent({ delay: 1000, callback: () => {
            this.scoreLayer.show();
        }, callbackScope: this});
    }

    public hideScores(): void {
        
        this.scoreLayer.hide();
    }

    public showPosition(): void {
        
        this.positionLayer.show();
    }

    public hidePosition(): void {
        
        this.positionLayer.hide(); 
    }

    public showPoints(): void {
        
        this.pointsLayer.show();
        this.passPoints.setText(GameVars.players[this.index].points.toString());

        for (let i = 0; i < 3; i++) {
            
            if (GameVars.players[this.index].tokens < i + 1) {
                if (this.tokens[i].visible) {
                    this.scene.tweens.add({
                        targets: this.tokens[i],
                        alpha: 0,
                        scaleX: 1.5,
                        scaleY: 1.5,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 500,
                        onComplete: () => {
                            this.tokens[i].visible = false;
                        }, 
                        onCompleteScope: this,
                        onStart: () => {
                            AudioManager.playSound("token");
                        },
                        onStartScope: this
                    });
                }
            }
        }
    }

    public removePlayer(): void {

        this.scene.tweens.add({
            targets: this,
            x: this.x + AdversaryContainer.LOSE_POSITION[this.index - 1].x,
            y: this.y + AdversaryContainer.LOSE_POSITION[this.index - 1].y,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            onComplete: () => {
                this.visible = false;
            },
            onCompleteScope: this
        });
    }

    public resetAI(): void {

        this.AI.reset();
    }

    public addCardToPlayerAI(): void {

        this.AI.addCardToPlayer(GameVars.topCardWaste, GameVars.currentTurn);
    }

    public removeCardToPlayerAI(card: CardValue): void {

        this.AI.removeCardToPlayer(card, GameVars.currentTurn);
    }

    public selectDeckOrWasteAI(): string {

        return this.AI.selectDeckOrWasteAI();
    }

    public selectCardAndStopAI(): {card: number, stop: boolean} {

        return this.AI.selectCardAndStopAI();
    }
}
